import React from "react";
import { Tag } from "antd";
import { capitalize } from "lodash";

import { activityPriorityColors } from "./activities";

const TypeBadge = ({ type }) =>
  type ? <Tag variant="outlined">{capitalize(type)}</Tag> : null;

const PriorityBadge = ({ priority }) =>
  priority ? (
    <Tag
      variant="outlined"
      color={activityPriorityColors[priority] || "default"}
    >
      {capitalize(priority)}
    </Tag>
  ) : null;

export { TypeBadge, PriorityBadge };
